module.exports = __webpack_public_path__ + "assets/laborer.svg?68661a9625317fcbc2a5153be14c9847";